module.exports = __webpack_public_path__ + "img/Certificate_2.aa465347.jpg";